import { render, staticRenderFns } from "./TipoDeEmprestimoForm.vue?vue&type=template&id=38bcd67d&scoped=true&lang=pug&"
import script from "./TipoDeEmprestimoForm.vue?vue&type=script&lang=js&"
export * from "./TipoDeEmprestimoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bcd67d",
  null
  
)

export default component.exports